"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientPosition = exports.isTouchEvent = exports.isMouseEvent = void 0;
// tslint:disable-next-line:no-any
function isMouseEvent(event) {
    var e = event;
    return typeof e.clientX === 'number';
}
exports.isMouseEvent = isMouseEvent;
// tslint:disable-next-line:no-any
function isTouchEvent(event) {
    var e = event;
    return !!e.touches;
}
exports.isTouchEvent = isTouchEvent;
/**
 * Gets the client position from either the mouse event or the first touch from a touch event
 */
// tslint:disable-next-line:no-any
function getClientPosition(event) {
    if (isMouseEvent(event)) {
        return { x: event.clientX, y: event.clientY };
    }
    if (isTouchEvent(event)) {
        return { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    throw Error('Could not identify event as either MouseEvent or TouchEvent');
}
exports.getClientPosition = getClientPosition;
//# sourceMappingURL=UserInteraction.js.map